import React from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingSpinner } from 'components/loading-spinner';

const VideoItemGeneratingThumbnail = () => {
  const { t } = useTranslation();
  return (
    <div className="ct-video-generating">
      <div className="ct-video-generating__placeholder" data-e2e="ct-video-generating__placeholder">
        <LoadingSpinner />
        <div className="ct-video-generating__label">{t('file_generating')}</div>
      </div>
    </div>
  );
};

export { VideoItemGeneratingThumbnail };
